// This source file is automatically generated.
// It MUST NOT be committed into source control.

export const version = 'v1.16.15';
export let stage = 'dev';
export const timestamp = 'Tue Sep 29 04:47:05 AM EDT 2026';
export const g4api = `https://g4-${stage}.v1.mrcapi.net`;
